import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { BasicInfoFields } from "./restaurant-form/BasicInfoFields";
import { ContactFields } from "./restaurant-form/ContactFields";
import { DescriptionField } from "./restaurant-form/fields/DescriptionField";
import { restaurantFormSchema, type RestaurantFormData } from "@/types/restaurantForm";
import { useRestaurantSubmission } from "@/hooks/useRestaurantSubmission";

interface RestaurantSubmissionFormProps {
  onSuccess?: () => void;
}

export function RestaurantSubmissionForm({ onSuccess }: RestaurantSubmissionFormProps) {
  const { handleSubmit: onSubmit, isSubmitting } = useRestaurantSubmission({ onSuccess });
  
  const form = useForm<RestaurantFormData>({
    resolver: zodResolver(restaurantFormSchema),
    defaultValues: {
      name: "",
      address: "",
      neighborhood_id: undefined,
      contact_email: "",
      website: "",
      phone: "",
      description: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <BasicInfoFields form={form} />
        <ContactFields form={form} />
        <DescriptionField form={form} />
        
        <Button type="submit" className="w-full" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit Restaurant"}
        </Button>
      </form>
    </Form>
  );
}